import { render, staticRenderFns } from "./SocialReportingHealth.vue?vue&type=template&id=3792a6d9&scoped=true&"
import script from "./SocialReportingHealth.vue?vue&type=script&lang=js&"
export * from "./SocialReportingHealth.vue?vue&type=script&lang=js&"
import style0 from "./SocialReportingHealth.vue?vue&type=style&index=0&id=3792a6d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3792a6d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
